<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Purchase/Service Order Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="5">
                        <b-input-group>
                            <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.orderno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="3">                            
                            <b-input-group >
                                <b-input-group-append><span class="input-group-text">Order Type</span></b-input-group-append>
                               <b-form-select v-model="model.jasa" :plain="true" :options="jasaMaterial" :state="!$v.model.jasa.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">                            
                        <b-input-group>
                            <b-input-group-append><span class="input-group-text">Date</span></b-input-group-append>
                            <b-form-input v-model="model.orderdate" type="date" @change="tanggalBerubah" :state="!$v.model.orderdate.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-form-row>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Requesition No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.requestno" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuPrShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Ref. Quotation No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.quotation" placeholder="Ref. Quotation No."></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>    
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor_id.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuVendorShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                                        
                    <b-input-group >
                        <b-input-group-prepend><label>Delivery Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.locationdeliv"  placeholder="Delivery Location" ></b-form-input>
                    </b-input-group>
                    <b-row align-h="between">
                        <b-col md="7">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Expected Received</label></b-input-group-prepend>
                               <b-form-input v-model="model.ExpectRcv" :state="!$v.model.ExpectRcv.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Expected Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.expectreceipt" type="date"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-form-row>
                        <b-col md="4" >
                            <b-input-group >
                                <b-input-group-prepend><label>Currency </label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select  v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                                </b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col md="8">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:80px;">Description</label></b-input-group-prepend>
                                <b-form-input v-model="model.remark" :state="!$v.model.remark.$error" placeholder="remark/description"></b-form-input>
                                <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.barter" class="mt-1">BARTER</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                </b-col>
                <b-col md="4">
                    <!-- <b-input-group >
                        <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.cashflow"  @keyup.13.native="showLkuCashflow('model')"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group> -->
                    <b-input-group>
                        <b-input-group-prepend><label>Internal Budget</label></b-input-group-prepend>
                        <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuBudgetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>

                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrdLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(description)="data">
                            <pre>{{data.item.description}}</pre>
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity | numFormat('0.[00]')}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(nilaidisc)="data">
                        {{data.item.nilaidisc|numFormat}}
                        </template>
                        <template v-slot:cell(nilainett)="data">
                        {{data.item.nilainett|numFormat}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editOrdLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-tabs card v-model="tabIndex">
                        <b-tab title="ORDER ITEM DETAIL" active>
                            <b-row h-align="center">
                                <b-col lg="6" xl="6" class="pl-0">
                                    <!-- <b-input-group>
                                        <b-input-group-prepend><label>Item</label></b-input-group-prepend>
                                        <b-form-select v-model="ordLinesObj.linetype" :plain="true" :options="linetypes" :state="!$v.ordLinesObj.linetype.$error"></b-form-select>
                                        <b-form-input readonly v-model="ordLinesObj.iteminfo" @keyup.13.native="showLkuCoa" :state="!$v.ordLinesObj.itemno.$error" style="width:60% !important;"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="showLkuCoa" id="glAccount">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group> -->
                                    <b-input-group>
                                        <b-input-group-prepend><label>Item</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="ordLinesObj.iteminfo" @keyup.13.native="showLkuCoa" :state="!$v.ordLinesObj.itemno.$error" ></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="showLkuCoa" id="glAccount">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                          <b-form-textarea :rows="3" :max-rows="13" v-model="ordLinesObj.description" :state="!$v.ordLinesObj.description.$error" ></b-form-textarea>
                                    </b-input-group>
                                    <b-form-row>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.quantity" @change="calcPrice()" type="number" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.unitsize" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >     
                                    <b-form-row>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" :state="!$v.ordLinesObj.unitprice.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:35px;">disc.</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.disc" @change="calcDiscValue()" ></b-form-input>
                                                <b-input-group-append><span class="input-group-text"> %</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >                      

                                </b-col>
                                <b-col lg="6" xl="5" class="pl-0">
                                    <b-form-row>
                                    <b-col xl="10">                            
                                        <b-input-group>
                                            <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                            <b-input-group-prepend>
                                            <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                            </b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="ordLinesObj.nilai" :precision="2" disabled></my-number>
                                        </b-input-group>
                                        <b-input-group>
                                            <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                                            <b-input-group-prepend>
                                            <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                            </b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="ordLinesObj.nilaidisc" :precision="2" @change.native="calcDiscPct()" ></my-number>
                                        </b-input-group>
                                    </b-col>
                                    </b-form-row >        

                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nilainett" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="2">                            
                                            <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="ordLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" :state="!$v.ordLinesObj.kenappn.$error">PPN(VAT)</b-form-checkbox>
                                        </b-col>
                                    </b-form-row >                      

                                    <b-form-row v-if="(ordLinesObj.kenappn==1)">
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.dppnlain" @change="calcTaxes()"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.ppn" @change="calcTaxes()" type="number" v-b-tooltip.hover :title="ordLinesObj.ppn"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >         
                                    <b-form-row>
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                <b-form-select v-model="ordLinesObj.pasalpph" :plain="true" :options="lookupPPH" ></b-form-select>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col xl="4">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.pph" type="number" v-b-tooltip.hover :title="ordLinesObj.pph"></b-form-input>
                                                <!-- <my-number v-model="ordLinesObj.pph" :precision="2" v-b-tooltip.hover :title="ordLinesObj.pph"></my-number> -->
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >                          
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="ORDER ITEM DIMENSION">
                            <b-row>
                                <b-col lg="8" xl="6"  class="pl-0">
                                    <v-dim :model="ordLinesObj" :key="updateDimDtl"></v-dim>
                                </b-col>
                            </b-row>
                        </b-tab>
                      </b-tabs>
                      <b-row class="justify-content-center mt-1">
                        <div style="width:400px;">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                <b-input-group-append>
                                    <b-button class="btn btn-success mr-1" @click="saveOrdLines()">Update</b-button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>

                      </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="5">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addOrdLines" >Add Order Detail</b-button>                          
                        <div class="ml-2">
                            Showing {{(ordLines.page - 1) * ordLines.limit + 1}}
                            to <span v-if="((ordLines.page * ordLines.limit)>ordLines.total)">{{ordLines.total}}</span> <span v-else>{{ordLines.page * ordLines.limit}}</span>
                            of {{ordLines.total}} entries
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="ordLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                    <b-pagination
                        align="right"
                        :total-rows="ordLines.total"
                        :per-page="ordLines.limit"
                        v-model="ordLines.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                       <b-row>
                            <b-col md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                                    <b-form-select v-model="model.postgroup" :plain="true" :options="postGroups" ></b-form-select>
                                </b-input-group>
                            </b-col>
                            <b-col md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>PO Grouping</label></b-input-group-prepend>
                                    <b-form-select v-model="model.typegroup" :plain="true" :options="poGroups" :state="!$v.model.typegroup.$error"></b-form-select>
                                </b-input-group>
                            </b-col>
                        </b-row>  
                       <b-row>
                            <b-col md="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Invoicing Term </label></b-input-group-prepend>
                                    <b-form-select v-model="model.invterm" :plain="true" :options="invoicingTerms" :state="!$v.model.invterm.$error" @change="onChangeInvTerm"></b-form-select>
                                </b-input-group>
                            </b-col>
                            <b-col md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>Payment Term</label></b-input-group-prepend>
                                    <b-form-input v-model="model.paymterm" placeholder="Description of Payment Term" ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>  
                        <div class="report-wraper">
                            <table style="width: 99%;">
                                <thead>
                                    <tr>
                                        <th width="80">Term</th>
                                        <th width="50">%</th>
                                        <th style="text-align:right" width="140">Amount</th>
                                        <th>Condition/Document</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in model.terms" :key="item.namaterm">
                                        <td>{{item.namaterm}}</td>
                                        <td>{{item.persentase}} %</td>
                                        <td style="padding:0 4px;">
                                            <my-number class="form-control text-right" v-model="item.nilai" :precision="2"></my-number>
                                        </td>
                                        <td style="padding:0 4px;">                           
                                            <b-form-input  v-model="item.syarat"></b-form-input>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                  
                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="(calcVAT===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-row class="mt-2">
                                        <b-form-checkbox  v-model="model.taxliable" value=1 unchecked-value=0  class="ml-3">
                                        PPN bisa dikreditkan
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="model.grossup" value=1 unchecked-value=0  class="ml-3">
                                        Gross Up W/H Tax (PPh)
                                        </b-form-checkbox>
                                        <b-form-checkbox  v-model="model.chargeable" value=1 unchecked-value=0 class="ml-3">
                                        Chargeable to Customer
                                        </b-form-checkbox>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-row class="justify-content-center mt-1">
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem"  isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>  
        <b-modal v-model="lkuPrShow" size="lg" :hide-footer="true" title="List of Purchase Request " :centered="true">
            <lku-pr @click="onSelectLkuPr" :key="model.jasa" :filter="{jasa:model.jasa}"></lku-pr>
        </b-modal>        
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget Items" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuBudgetinternal from "../lookup/lkuBudgetinternalline";
import vDim from "../lookup/dim";
import lkuPr from "../lookup/lkuPr";
import lkuVendor from "../lookup/lkuVendor";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCoa from "../lookup/lkuCoa";
import procure from "../../apis/procure";
import dimension from "../../apis/dimension";
import logistic_pr from "../../apis/logistic_pr";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim, lkuBudgetinternal, lkuPr,lkuVendor, lkuItem,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            jasa: { required },
            orderdate: { required },
            vendor_id: { required },
            vendor: { required },
            // requestno: { required:requiredIf('use_requisition') },
            ExpectRcv: { required },
            remark: { required },
            // postgroup: { required },
            typegroup: { required },
            matauang: { required },
            invterm: { required },
            // kodecash: { required },
        },
        ordLinesObj: {
            itemno: { required },
            description: { required },
            quantity: { decimal, required },
            unitprice: { decimal, required },
            nilai: { decimal, required },
            dppnlain: { numeric, required },
            disc: { decimal },
            kenappn: { required },
            ppn: { decimal },
            nilainett: { decimal },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
          isLoading:false,
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
        lkuBudgetShow: false,
        lkuPrShow:false,
        lkuCoaShow:false,
        lkuItemShow:false,
        itemList:{},
        lkuVendorShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 10,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        postGroups:[],poGroups:['CAPEX','OPEX','BARTER'],
        closingDocs : [{value:'STANDARD',text:'STANDARD'}],
        currency:[{value:'IDR',text:'IDR'}],
        invoicingTerms : [{value:'3TERM',text:'3 terms : 40,50,10'},{value:'4TERM',text:'4 terms : 10,35,45,10'},{value:'COD',text:'COD (1 Term)'}],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        linetypes : [{ value: 1, text: 'Master Item ' },{ value: 3, text: 'GL Account' }],
        jasaMaterial : [{ value: 1, text: 'Service Order' }, { value: 0, text: 'Material Order' }],
        ordLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Master Item",
                },
                {
                    key: "description",
                    label: "Description",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilainett",
                    label: "Amount NETTO",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "Amount VAT",
                    thStyle: "width:90px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "pasalpph",
                    label: "PPh",
                    thStyle: "width:80px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 10,
            total: 0,
        },
        model: {
            jasa: 0,
            orderdate: moment().format('YYYY-MM-DD'),
            vendor_id: '',
            vendor: '',
            requestno: '',
            ExpectRcv: '',
            remark: '',
            postgroup: '',
            typegroup:'OPEX', 
            matauang:this.$store.state.user.matauang, 
            compcode:this.$store.state.user.compcode,
            invterm: 'COD',
            kodecash: '',
            terms:[], 
            locationdeliv:this.$store.state.user.compaddr},
        ordLinesObj: {
            linetype: 1,
            itemno: '',iteminfo:'',
            description: '',
            quantity: 0, unitzise:'',
            unitprice: 0,
            nilai: 0,
            dppnlain: 100,
            disc: 0,
            kenappn: 0,
            ppn: 10,
            pasalpph: '',
            nilainett: 0,
        },
        tabIndex:0,
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    // use_requisition(){
    //     return (this.$store.state.user.use_procure == 1);
    // },
    // invterm(){
    //     return this.model.invterm;
    // },
    unitprice(){
        return this.ordLinesObj.unitprice;
    },
    pasalpph(){
        return this.ordLinesObj.pasalpph;
    },    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
    pasalpph: function(newval) {
        const item = this.lookupPPH.find(p => p.value==newval);
        this.ordLinesObj.pph=item.pph;
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },    
  },
  created: async function(){
        if (this.$route.params.pohdrkey)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            const [a,b,c,e,data] = await Promise.all([procure.postgroup(), procure.pasalpph(),procure.currency(),procure.paymterms(),procure.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.invoicingTerms = e;
            // const data = await procure.detail(this.$route.params);  
            const row = data[0][0];
            if (row.isreject==1) row.send2wf=0;
            if (row.send2wf==1){
                if (row.isreviewed==1){
                    this.saveEnabled=true;
                } else {
                    this.saveEnabled=false;
                }
            }            
            row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.ordLines.items = data[1];
            this.ordLines.total = this.ordLines.items.length;
            this.ordLines.total=this.ordLines.items.length;
            this.model.terms = data[2];

            const receiving = data[3]
            if (receiving.length>0) {
                this.saveEnabled=false;
               toastr.warn('View Only can not Save data, because Receiving of this PO already done');
            }

            this.calcTotalDtlOrder();
            this.tanggalBerubah();
                this.updateDimHdr = !this.updateDimHdr;
                // this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.orderdate  = moment().format('YYYY-MM-DD');
            const [a,b,c,e] = await Promise.all([procure.postgroup(), procure.pasalpph(),procure.currency(),procure.paymterms()]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.invoicingTerms = e;
        }
  },
  methods: {
    onSelectLkuBudget: async function (_selected) {
        try {
            this.model.remark = _selected.uraian;
            this.model.budgetname = _selected.uraian;
            this.model.budgetnumber = _selected.nomorintern;
            this.model.jccostname = _selected.jccostname;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;
            this.model.DimTableKey = _selected.DimTableKey;
            this.budgetbalance = _selected.ibbudgetamt -_selected.requestamt;

            this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format('YYYY-MM-DD') : '';
            this.dimension.forEach((dim) => {
                if (_selected[dim.value]) {
                    this.model[dim.value] = _selected[dim.value];
                    this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                    this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                }
                if (dim.RelatedObj=='internalbudget') {
                    this.model[`${dim.value}`] = _selected.nomorintern;
                    this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
                    this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
                }
            });
            this.updateDimHdr=!this.updateDimHdr;

            this.lkuBudgetShow=false;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },

    closeOrdLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOrdLines : function () {
        this.closeOrdLines();
        const linetype=this.ordLines.selected ? this.ordLines.selected.linetype : 1;
        const obj={_showDetails:true};
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        this.ordLinesObj.linetype=linetype;
        this.ordLinesObj.unitsize='EACH';
        this.ordLinesObj.quantity = 1;
        this.ordLinesObj.kenappn = 1;
        this.ordLinesObj.dppnlain = 100;
        this.ordLinesObj.ppn = this.tarifPPN;
        this.updateDimHdr2Dtl(this.ordLinesObj);
        this.ordLines.items.push(obj);
        this.ordLines.total=this.ordLines.items.length;
        setTimeout(() => {
            const bfore = this.ordLines.page;
            const after =Math.ceil(this.ordLines.total/this.ordLines.limit);
            if (bfore != after){
                this.ordLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${ordLines.total} items`,'Line/Detail PR',10000);
            }

        }, 100);
        this.inputLineBerlanjut=1;
    },
    editOrdLines : function (obj,callback) {
        this.closeOrdLines();
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.ordLinesObj[dim.value] = obj[dim.value];
                this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.tabIndex=0;
        this.inputLineBerlanjut=0;
        callback();
    },
    delOrdLines: function (index) {
        if (index > -1) {
            // this.ordLines.items.splice(index, 1);
            const posisi = (this.ordLines.page-1)*this.ordLines.limit;
            this.ordLines.items.splice(posisi+index, 1);
        }
        this.ordLines.total=this.ordLines.items.length;
        this.calcTotalDtlOrder();
    },
    saveOrdLines: async function (callback) {
        this.ordLinesObj.pasalpph= this.ordLinesObj.pasalpph || 'N/A';
        this.ordLinesObj.linetype= this.ordLinesObj.linetype || 1;

        this.calcPrice();
        if (this.invalidOrdLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
           if (this.tabIndex===0) {
                for (var key in this.ordLinesObj) {
                    this.ordLines.selected[key] = this.ordLinesObj[key];
                }
                this.calcTotalDtlOrder();
               this.tabIndex=1;
               return
           }
            let datadim=this.ordLinesObj;
            datadim.TableName = 'po_line';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.ordLinesObj) {
                        this.ordLines.selected[key] = this.ordLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.ordLines.selected[dim.value] = datadim[dim.value];
                            this.ordLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.ordLines.total=this.ordLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlOrder();
                    this.ordLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addOrdLines();
                        this.$v.ordLinesObj.$reset();                        
                    }
                } else {
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
                this.isLoading=true;            
                this.model.TableName = 'po_header';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.pohdrkey = this.model.pohdrkey || '';
                    this.model.orderno = this.model.orderno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.orderdate = moment(row.orderdate).format('YYYY-MM-DD');
                    row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    let lineno=1;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if ((item.itemno || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        // await procure.insert(row);
                        // toastr.success("Complete successfully", "Save Order");
                        const hasil= await procure.insert(row);
                            this.isLoading=false;            
                        toastr.success(`Success, Trx.Number ${hasil.orderno}`, "Save Purchase Order",10000);
                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                const tanggal = this.model.orderdate;
                                this.model.ttlamtdue = 0;
                                this.model.ttlnetto = 0;
                                this.model.nilaippn = 0;
                                const keys = ['ttlamtdue','ttlnetto', 'nilaippn'];                        
                                for (var key in this.model) {
                                    if (keys.indexOf(key) == -1) {
                                      this.model[key] = '';
                                    }
                                }
                                this.model.orderdate = tanggal;
                                this.ordLines.items=[];
                                this.ordLines.total=this.ordLines.items.length;
                                this.calcTotalDtlOrder();
                                this.$v.model.$reset();                        

                            }
                    } else {
                        toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                        this.isLoading=false;            
                    }
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;            
                    this.isLoading=false;            
                }

            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuPr: async function (_selected) {
        this.model.requestkey = _selected.requestkey;
        this.model.requestno = _selected.requestno;
        this.model.barter = _selected.barter || this.model.barter;
        // this.model.expectreceipt = _selected.jasastart ? _selected.jasastart : _selected.expectreceipt;
        // this.model.expectreceipt = this.model.expectreceipt ? moment(this.model.expectreceipt).format('YYYY-MM-DD') : '';
            this.model.jccostname = _selected.jccostname;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;

        this.lkuPrShow=false;

        // ambil dari API detail item dari MPR dg key  requestkey atau requestno
        // Collection  item dari MPR dimasukkan ke  ordLines.item
        
        const data = await logistic_pr.detail({requestkey:_selected.requestkey}); 
        const row = data[0][0]; 
        
        this.model.orderdate = row.requestdate ? moment(row.requestdate).format('YYYY-MM-DD') : '';
        row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
        for (var key in row) {
            this.model[key] = row[key];
        }
        
        this.ordLines.items = data[1];
        this.model.terms = [];
        this.calcTotalDtlOrder();
        this.tanggalBerubah();
        this.cekTotalTerm();
        
        this.updateDimHdr = !this.updateDimHdr;
            
    },
    showLkuCoa() {
        if (this.ordLinesObj.linetype == 3) this.lkuCoaShow=true;
        else this.lkuItemShow=true;
    },
    onSelectLkuCoa(_selected) {
        this.ordLinesObj.iteminfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.ordLinesObj.partnumber = _selected.namaacc;
        this.ordLinesObj.itemno = _selected.kodeacc;
        this.ordLinesObj.itemname = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.ordLinesObj.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        // this.ordLinesObj.description =  lkuData.selected.itemname.trim() + ' | ' + lkuData.selected.partnumber.trim();
        this.ordLinesObj.partnumber = lkuData.selected.partnumber;
        this.ordLinesObj.itemno = lkuData.selected.itemno;
        this.ordLinesObj.itemname = lkuData.selected.itemname;
    },
    onSelectLkuVendor: async function (_selected) {
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.lkuVendorShow=false;
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.ordLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlOrder: function () {
        this.calcVAT = this.calcVAT || 1;
        let nilaippn = 0;
        let ttlnetto = 0;
        let ttlamtdue = 0;
        // let totalpph = 0;
        this.ordLines.items.forEach( function (trx) {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
                nilaippn += (trx.nilaippn || 0);
                ttlamtdue = ttlnetto + (nilaippn || 0);
                // totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
        if (this.calcVAT == 1){
            this.model.nilaippn = nilaippn;
        }
        this.model.ttlamtdue = ttlamtdue;
        // this.model.totalpph = totalpph;
    },
    calcAmountDue : function() {
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
    }, 
    calcTaxes : function() {
        this.ordLinesObj.nilainett = parseFloat(this.ordLinesObj.nilai) - parseFloat(this.ordLinesObj.nilaidisc || 0);
        this.ordLinesObj.dpp = parseFloat(this.ordLinesObj.nilai) * parseFloat(this.ordLinesObj.dppnlain) / 100;
        this.ordLinesObj.nilaippn = 0;
        if (this.ordLinesObj.kenappn == 1) {
            // this.ordLinesObj.ppn = this.ordLinesObj.ppn || this.tarifPPN;
            this.ordLinesObj.nilaippn = parseFloat(this.ordLinesObj.ppn) / 100 * this.ordLinesObj.dpp;
        } else {
            this.ordLinesObj.dpp = 0;
            this.ordLinesObj.ppn = 0;
        }

        this.ordLinesObj.nilaidue = this.ordLinesObj.nilainett + this.ordLinesObj.nilaippn;
    },

    calcPrice : function () {
        this.ordLinesObj.nilai = parseFloat(this.ordLinesObj.quantity) * parseFloat(this.ordLinesObj.unitprice);
        if (this.ordLinesObj.disc > 0) {
            this.ordLinesObj.nilaidisc = this.ordLinesObj.disc * this.ordLinesObj.nilai / 100.0;
        };
        // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
        this.calcTaxes();
    },
    calcDiscValue : function () {
        this.ordLinesObj.nilaidisc = parseFloat(this.ordLinesObj.disc) * parseFloat(this.ordLinesObj.nilai) / 100.0;
        this.calcTaxes();
    },
    calcDiscPct : function () {
        this.ordLinesObj.disc = (parseFloat(this.ordLinesObj.nilaidisc) / parseFloat(this.ordLinesObj.nilai)) * 100.0;
        this.calcTaxes();
        // this.$forceUpdate();
    },
    onChangeInvTerm : function (newval) {
        // console.log('this.invoicingTerms',this.invoicingTerms)
        if (newval=='COD'){
            this.model.terms=[];
        } else {
            this.model.terms = [];
            // var selected = _.find(this.invoicingTerms, { value: newval });
            const selected = this.invoicingTerms.find(i => i.value === newval);
            const terms=selected.text.split(':')[1].split(',');
            for (let index = 0; index < terms.length; index++) {
                this.model.terms.push({ namaterm: 'Term#' + (index+1), persentase: parseFloat(terms[index]), nilai: (parseFloat(terms[index])/100) * parseFloat(this.model.ttlamtdue) });
            }
        };
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    // termEdit : function (row) {
    //     console.log('Edit : ',row);
    //     for (let index = 0; index < this.model.terms.length; index++) {
    //         this.model.terms[index].selected=false;
    //     }
    //     row.selected=true;
    //     this.termEdited=row;
    // },
    cekTotalTerm : function () {
        var hasil=true;
        if (this.model.terms.length>0) 
        {
            hasil=false;
            var totalTerm=0;
            for (let index = 0; index < this.model.terms.length; index++) {
                totalTerm = totalTerm + parseFloat(this.model.terms[index].nilai);
            }
            if (totalTerm == this.model.ttlamtdue) hasil=true;
        }
        return  hasil;
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.poinput')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
